import AjaxCommons from '@/services/ajax-commons';

export interface PageList {
    id: number;
    title: string;
    aktiv: boolean;
}

export interface Page extends PageList {
  content: string;
}

class PageApiAgentImpl {
  constructor(private ajax = AjaxCommons) {}

  public getList: () => Promise<PageList[]> = () => {
    return this.ajax.get('type=page&list=1');
  }

  public getFullList: () => Promise<PageList[]> = () => {
    return this.ajax.get('type=page&list=1&all=1');
  }

  public getById: (id: string) => Promise<Page> = (id) => {
    return this.ajax.get('type=page&id=' + id);
  }

  public update = (id: string, title: string, active: boolean, content: string) => {
    const aktiv: number = active ? 1 : 0;
    return this.ajax.post(`type=page`, {
      id, title, aktiv, content,
    }, 'put').then(result => {
      return !!(result && result.result);
    });
  }

  public add = (title: string, active: boolean, content: string) => {
    const aktiv: number = active ? 1 : 0;
    return this.ajax.post(`type=page`, {
      title, aktiv, content,
    }, 'put');
  }

  public remove = (id: string) => {
    return this.ajax.post(`type=page`, {
      id,
    }, 'delete');
  }
}

const PageApiAgent = new PageApiAgentImpl();

export default PageApiAgent;
export { PageApiAgentImpl };
